import type {
  EstadoTerceiraPortaOficina,
  IdZonaOperacaoTerceiraPorta,
} from '../../dominio/didatico/oficinaTerceiraPorta'
import type { PerfilVeiculo } from '../../dominio/didatico/perfilVeiculo'
import type { FerramentaOficinaCorte } from '../../dominio/didatico/oficinaCorte'
import { chaveProgressoIntervencao, resolverInteracaoTerceiraPorta } from '../../dominio/didatico/interacaoOficina'
import { estadoZonasTerceiraPorta } from './estadoZonas'
import { MarcadorZona3D } from './MarcadorZona3D'
import { posicaoNoQuadroDaTerceiraPorta, quadroDaTerceiraPorta } from './quadroDaTerceiraPorta'
import { zonasOperacaoTerceiraPorta, type IdLadoTerceiraPorta } from './zonasOperacaoTerceiraPorta'

interface Props {
  perfil: PerfilVeiculo
  lado: IdLadoTerceiraPorta
  selecionada: IdZonaOperacaoTerceiraPorta | null
  /** Estado da aba: é o que faz o marcador registrar o lado já cortado. */
  estadoTerceiraPorta: EstadoTerceiraPortaOficina
  ferramenta: FerramentaOficinaCorte
  progressoEstrutural: Record<string, number>
  aoSelecionar: (id: IdZonaOperacaoTerceiraPorta) => void
  /** Pressionar o marcador já começa a fechar a ferramenta — soltar em qualquer lugar interrompe (ver App.tsx). */
  aoPressionarFerramenta: (id: IdZonaOperacaoTerceiraPorta) => void
  aoSoltarFerramenta: () => void
  aoPrevisualizar: (id: IdZonaOperacaoTerceiraPorta) => void
}

/** Marcadores grandes o bastante para clique e toque; a ferramenta encaixa neles. */
export function ZonasOperacaoTerceiraPorta3D({
  perfil,
  lado,
  selecionada,
  estadoTerceiraPorta,
  ferramenta,
  progressoEstrutural,
  aoSelecionar,
  aoPressionarFerramenta,
  aoSoltarFerramenta,
  aoPrevisualizar,
}: Props) {
  const estados = estadoZonasTerceiraPorta(estadoTerceiraPorta)
  const quadro = quadroDaTerceiraPorta(perfil, lado, estadoTerceiraPorta)

  if (estadoTerceiraPorta.removida) return null

  return (
    <group>
      {zonasOperacaoTerceiraPorta(perfil, lado).map((zona) => {
        const intencao = resolverInteracaoTerceiraPorta({ ferramenta, zona: zona.id, estado: estadoTerceiraPorta })
        return <MarcadorZona3D
          key={zona.id}
          posicao={posicaoNoQuadroDaTerceiraPorta(quadro, zona.posicao)}
          // o anel deita no plano da chapa lateral, cuja normal é o eixo X
          rotacao={[0, Math.PI / 2 + quadro.giroY, 0]}
          nome={zona.nome}
          descricao={intencao.descricao}
          disponivel={intencao.disponivel}
          progressoEstrutural={intencao.disponivel
            ? progressoEstrutural[chaveProgressoIntervencao(intencao.operacao, zona.id)] ?? 0
            : 0}
          estado={estados[zona.id]}
          selecionada={zona.id === selecionada}
          nomeObjeto={`zona-operacao-terceira-porta:${zona.id}`}
          aoSelecionar={() => aoSelecionar(zona.id)}
          aoPressionarFerramenta={() => aoPressionarFerramenta(zona.id)}
          aoSoltarFerramenta={aoSoltarFerramenta}
          aoPrevisualizar={() => aoPrevisualizar(zona.id)}
        />
      })}
    </group>
  )
}
